import config from './config'
import utils from './utils'

const widget = ({ strings, url }) => `
  <table class="hiss_widget">
    ${header(strings)}
    <tbody></tbody>
  </table>
  ${ctaRow({ strings: strings, url: url })}`

const header = strings => `<thead>
  <tr class="hiss_thead">
    <th class="hiss_name">
      <div class="hiss_name__wrapper">
        <div class="hiss_name__block">${strings.title}</div>
        <div class="hiss_name__chart">${strings.chart}</div>
        <div class="hiss_name__price">${strings.price}&nbsp;/<br>${strings.change}</div>
      </div>
    </th>
    <th class="hiss_activity">${strings.activity}</th>
    <th class="hiss_chart">${strings.chart}</th>
    <th class="hiss_price">
      ${strings.price} <span class="hiss_change__item">/</span>
      <div class="hiss_change__item">${strings.change}</div>
    </th>
    <th class="hiss_change">${strings.change}</th>
    <th class="hiss_buy"></th>
  </tr>
</thead>`

const printActivityBadge = ({ item, strings }) => {
    const badge = document.createElement('div')
    const record = document.createElement('div')
    const gloss = document.createElement('div')

    badge.className = 'hiss_activity__badge'
    record.className = 'hiss_activity__record'
    gloss.className = 'hiss_activity__gloss'
    badge.appendChild(record)
    badge.appendChild(gloss)

    if (item.valueQuote) {
        // price record cases
        record.innerText = `${strings[item.period + '_' + item.recordType]}`
        record.classList.add(`hiss_activity__record--${item.recordType}`)
        gloss.innerText = utils.format(item.valueQuote)
        gloss.classList.add(`hiss_activity__gloss--${item.recordType}`)
    } else {
        // high volatility cases
        if (item.endTime === null) {
            badge.dataset.time = item.beginTime
            record.innerText = strings.volatility
            record.classList.add(`hiss_activity__record--volatility`)
            gloss.innerText = utils.getHoursLast({
                time: item.beginTime,
                strings: strings
            })
        } else {
            badge.dataset.time = item.endTime
            record.innerText = strings.volatility_end
            record.classList.add(`hiss_activity__record--volatility-end`)
            gloss.innerText = utils.getHoursAgo({
                time: item.endTime,
                strings: strings
            })
        }
    }

    return badge
}

const ctaRow = ({ strings, url }) => `
  <div class="hiss_cta">
    <a 
      href="${url}" 
      class="hiss_cta-link" 
      data-icid="button" 
      data-icid-id="btn_wdg_hot_cta">
      ${strings.link}
    </a>
  </div>`

const updatePrices = ({ node, data, strings }) => {
    const list = node.querySelectorAll(`.hiss_row`)

    ;[].forEach.call(list, function (row) {
        const instrument = data.find(i => i.code === row.dataset.code)

        if (instrument !== undefined) {
            const priceCells = row.querySelectorAll('.hiss_price__item')

            ;[].forEach.call(priceCells, cell => {
                cell.innerText = utils.format(instrument.price)
                cell.classList.remove('hiss_price__item--red')
                cell.classList.remove('hiss_price__item--green')
                if (instrument.color) {
                    cell.classList.add(`hiss_price__item--${instrument.color}`)
                }
            })

            const percentCells = row.querySelectorAll('.hiss_change__item')

            ;[].forEach.call(percentCells, cell => {
                cell.innerText = getPercentage(instrument.percentChange)
                cell.classList.remove('hiss_change__item--red')
                cell.classList.remove('hiss_change__item--green')
                cell.classList.add(getPercentageClass(instrument.percentChange))
            })
        }
    })

    const volatilityBadges = node.querySelectorAll(
        '.hiss_activity__badge[data-time]'
    )

    ;[].forEach.call(volatilityBadges, badge => {
        const isVolatility = badge.firstChild.classList.contains(
            'hiss_activity__record--volatility'
        )
        const isVolatilityEnd = badge.firstChild.classList.contains(
            'hiss_activity__record--volatility-end'
        )

        if (isVolatility || isVolatilityEnd) {
            const badgeUpdateObj = {
                time: badge.dataset.time,
                strings: strings
            }

            badge.querySelector(
                '.hiss_activity__gloss'
            ).innerText = isVolatility
                ? utils.getHoursLast(badgeUpdateObj)
                : utils.getHoursAgo(badgeUpdateObj)
        }
    })
}

const getPercentage = percentChange => {
    if (percentChange > 0) return `+${percentChange}%`
    else return `${percentChange.replace('-', '−')}%`
}

const getPercentageClass = percentChange =>
    `hiss_change__item--${percentChange > 0 ? 'green' : 'red'}`

const printLastItems = ({ items, data, strings, node }) => {
    const tbody = node.querySelector('tbody')

    items.forEach(item => {
        const row2update = tbody.querySelector(`tr[data-code="${item.symbol}"]`)

        if (row2update) tbody.removeChild(row2update)

        const instrument = data.find(i => i.code === item.symbol)
        const row = document.createElement('tr')

        row.dataset.code = instrument.code
        row.dataset.icidId = `btn_wdg_hot_${instrument.code}`
        row.dataset.icid = 'button'
        row.className = 'hiss_row'
        row.insertAdjacentHTML(
            'afterbegin',
            `
      <td class="hiss_name">
        <div class="hiss_name__wrapper">
          <div class="hiss_name__block">
            <a class="hiss_name__link">${instrument.name}</a>
            <div class="hiss_name__code">${instrument.code}</div>
          </div>
          <div class="hiss_name__chart">
            <img src="https://quote.stormgain.com/chart/${
                instrument.code
            }?width=80&height=36&stroke=1&color=ffffff"
                 width="70" height="36" alt="">
          </div>
          <div class="hiss_name__price">
            <div class="hiss_price__item">${utils.format(
                instrument.price
            )}</div>
            <div class="hiss_change__item ${getPercentageClass(
                instrument.percentChange
            )}">${getPercentage(instrument.percentChange)}</div>
          </div>
        </div>
        <div class="hiss_name__badge">${
            printActivityBadge({ item: item, strings: strings }).outerHTML
        }</div>
      </td>
      <td class="hiss_activity">
        ${printActivityBadge({ item: item, strings: strings }).outerHTML}
      </td>
      <td class="hiss_chart">
        <img src="https://quote.stormgain.com/chart/${
            instrument.code
        }?width=80&height=36&stroke=1&color=ffffff"
             width="80" height="36" alt="">
      </td>
      <td class="hiss_price">
        <div class="hiss_price__item">${utils.format(instrument.price)}</div>
        <div class="hiss_change__item ${getPercentageClass(
            instrument.percentChange
        )}">${getPercentage(instrument.percentChange)}</div>
      </td>
      <td class="hiss_change">
        <div class="hiss_change__item ${getPercentageClass(
            instrument.percentChange
        )}">${getPercentage(instrument.percentChange)}</div>
      </td>
      <td class="hiss_buy">
        <span class="hiss_buy__btn" data-icid="button" data-icid-id="btn_wdg_hot_${
            instrument.code
        }">${strings.trade}</span>
      </td>`
        )

        if (config.limit && tbody.childElementCount >= config.limit)
            tbody.removeChild(tbody.lastElementChild)

        tbody.insertBefore(row, tbody.firstChild)
    })
}

export default {
    widget,
    updatePrices,
    printLastItems
}
